import { usePrevious } from '@dni-react-hooks/use-previous'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useCallback } from 'react'
import isEqual from 'react-fast-compare'
import { useFpCampaignCartStore } from './useFpCampaignCartStore'

export const useFpCampaignSetDefaultValues = (campaignId: number, campaignCode: string) => {
  const [, setCartValues] = useFpCampaignCartStore(campaignId)
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCode)
  const prevExhibitorSettings = usePrevious(exhibitorSettings)

  /**
   * 1. 初始化時(如果沒有 prevExhibitorSettings 代表剛取得資料)，則設置 isGiveawayDispatch
   * 2. 使用者如果已經手動調整過則不會觸發設置 isGiveawayDispatch
   * 3. 如果 exhibitorSettings 有變化則重新設置 isGiveawayDispatch
   */
  const setDefaultIsGiveawayDispatch = useCallback(() => {
    if (!exhibitorSettings) return
    if (!prevExhibitorSettings) {
      setCartValues((prev) => {
        if (prev.isGiveawayDispatch === null) {
          return {
            ...prev,
            isGiveawayDispatch: exhibitorSettings.enable_delivery_giveaway,
          }
        }
        return prev
      })
      return
    }
    if (!isEqual(exhibitorSettings, prevExhibitorSettings)) {
      setCartValues((prev) => {
        return {
          ...prev,
          isGiveawayDispatch: exhibitorSettings.enable_delivery_giveaway,
        }
      })
    }
  }, [exhibitorSettings, prevExhibitorSettings, setCartValues])

  return {
    setDefaultIsGiveawayDispatch,
  }
}
